import { Dispatch } from 'redux';

import { post, RequestExceptionWithResponse } from '@eika-infrastruktur/request';

import { AppState } from '../reducers';
import { saveConsent } from './consent';
import { setPin } from './pin';
import { getRequestHeaders } from './tools';
import { actionTypes, AppActions } from './types';

type Action<T> = import('./types').Action<T>;
type SendOrderResponse = import('../generated-types').SoknadStatus;

export interface SendOrderStartedAction extends Action<typeof actionTypes.SEND_ORDER_STARTED> {
    type: typeof actionTypes.SEND_ORDER_STARTED;
}

export interface SendOrderFulfilledAction extends Action<typeof actionTypes.SEND_ORDER_FULFILLED> {
    type: typeof actionTypes.SEND_ORDER_FULFILLED;
    payload: SendOrderResponse;
}

export interface SendOrderFailedAction extends Action<typeof actionTypes.SEND_ORDER_FAILED> {
    type: typeof actionTypes.SEND_ORDER_FAILED;
    payload: RequestExceptionWithResponse;
}

export type SendOrderActions = SendOrderStartedAction | SendOrderFulfilledAction | SendOrderFailedAction;

export const sendOrderStarted = (): SendOrderStartedAction => ({
    type: actionTypes.SEND_ORDER_STARTED,
});
export const sendOrderFulfilled = (json: SendOrderResponse): SendOrderFulfilledAction => ({
    type: actionTypes.SEND_ORDER_FULFILLED,
    payload: json,
});
export const sendOrderFailed = (error: RequestExceptionWithResponse): SendOrderFailedAction => ({
    type: actionTypes.SEND_ORDER_FAILED,
    payload: error,
});

export const sendOrder = async (dispatch: Dispatch<AppActions>, getState: () => AppState): Promise<void> => {
    const { loader, application, cards, context } = getState();
    const { hasSentOrder, isSendingOrder } = loader;
    const { sakId, kredittgrense, forfallsdato, pinkode } = application;
    const { summarySetPinEnabled } = context.config.data.text;
    const { kortId } = cards;

    if (!hasSentOrder && !isSendingOrder) {
        const data = {
            sakId,
            forfallsdato: kortId === '' ? Number(forfallsdato) : null,
            kredittgrense,
        };

        try {
            dispatch(sendOrderStarted());
            const response: SendOrderResponse = await post(
                `${actionTypes.RESOURCE_PATH}/application/order`,
                data,
                getRequestHeaders(context.config.bankregnr),
            );
            dispatch(sendOrderFulfilled(response));

            /* Save Consent */
            await saveConsent(dispatch, getState);

            /* Set Pin */
            if (summarySetPinEnabled === 'true' && !!pinkode) await setPin(dispatch, getState);
        } catch (error) {
            dispatch(sendOrderFailed(error));
        }
    }
};
